import {Component} from 'react';
import h from 'react-hyperscript';
import {p} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';
// eslint-disable-next-line max-len
import SurveyMessaging from 'Pages/ReportCardOverview/SurveyReportStatus/SurveyMessaging/SurveyMessaging';
import SurveyStats from './SurveyStats/SurveyStats';
// eslint-disable-next-line max-len
import {replaceCloseDatePlaceholder, replaceReportNamePlaceholder} from 'Src/utils/utils';

class SurveyCompleteState extends Component {
  sanitize(subtitle) {
    const reportName = this.props.latestReport.report_card_name;
    const expirationDate = new Date(
        this.props.userStatus.dates.survey_close_date
            .replace('-', '/')
    );
    return replaceCloseDatePlaceholder(
        replaceReportNamePlaceholder(subtitle, reportName),
        expirationDate
    );
  }

  render() {
    const expirationDate = this.props.expirationDate;
    const subtitle = this.props.content.subtitle;

    return h(
        BasicCard,
        {
          type: 'basic',
          className: 'report-overview__status status--no-report flex',
          id: `report-overview--${this.props.content.statusId}`,
        },
        h(
            'div',
            {
              className: 'flex--space-between flex--wrap',
            },
            [
              h(
                  SurveyMessaging,
                  {
                    borderRight: Boolean(expirationDate),
                    surveyTitle: this.props.surveyTitle,
                    latestReport: this.props.latestReport,
                    title: this.props.content.title,
                    ctas: this.props.content.ctas,
                    date: this.props.reportAvailableDate,
                    userStatus: this.props.userStatus,
                    districtId: this.props.userStatus.district_id,
                    googleUser: this.props.googleUser,
                    csrf: this.props.csrf,
                    idToken: this.props.idToken,
                    shareInfo: this.props.shareInfo,
                    SubtitleComponent: h(
                        p,
                        {
                          key: `survey-messaging-subtitle--${subtitle.partOne}`,
                          className: 'text--grey survey-messaging__subtitle',
                          dangerouslySetInnerHTML: this.sanitize(subtitle),
                        },
                    ),
                    statusId: this.props.content.statusId,
                    shareUrl: this.props.shareUrl,
                    setProductWindowsLoading:
                      this.props.setProductWindowsLoading,
                  },
                  null
              ),
          expirationDate ?
            h(
                SurveyStats,
                {
                  respondents: this.props.numRespondents,
                  expirationDate,
                  daysLeft: this.props.daysLeft,
                },
                null
            ) :
            null,
            ]
        )
    );
  }
}

export default SurveyCompleteState;
